import { useLayoutEffect, useRef } from "react";
import { useWindowSize } from "./useWindowSize";

const setViewWidthAndHeight = (width: number, height: number) => {
  document.body.style.setProperty(`--vw`, `${width * 0.01}px`);
  document.body.style.setProperty(`--vh`, `${height * 0.01}px`);
};

/**
 * Publishes the --vw/--vh custom properties behind the SCSS vw()/vh() helpers.
 * 100vh is unreliable on iOS: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
export const useViewportCssVars = () => {
  const { width, height } = useWindowSize();
  const initialized = useRef(false);

  // The vars have no static fallback, so the first pass has to run during
  // render: child layout effects run before the parent's and would otherwise
  // measure against an unresolved var.
  if (!initialized.current) {
    initialized.current = true;
    setViewWidthAndHeight(width, height);
  }

  useLayoutEffect(() => {
    setViewWidthAndHeight(width, height);
  }, [width, height]);
};
